<template>
  <div class="mediaReportDetailChartPhoto">
    <kendo-chart
      ref="chart"
      :legend-position="'top'"
      :series-defaults-type="'area'"
      :category-axis-categories="$parent.$data.categories"
      :category-axis-major-grid-lines-visible="false"
      :category-axis-labels-rotation="'auto'"
      :value-axis-labels-format="'{0}'"
      :value-axis-line-visible="false"
      :series-defaults-style="'smooth'"
      :value-axis-axis-crossing-value="'-10'"
      :tooltip-visible="true"
      :tooltip-format="'{0}'"
      :tooltip-template="$parent.$data.tooltiptemplate"
      :theme="'sass'"
    >
      <kendo-chart-series-item
        :data="$parent.$data.totalRuns"
        :line-style="'smooth'"
        color="lightgray"
        name="Total Runs"
      />
      <kendo-chart-series-item
        :data="$parent.$data.noSpeedRuns"
        :line-style="'smooth'"
        color="firebrick"
        name="No Speed Runs"
      />
      <kendo-chart-series-item
        :data="$parent.$data.noPhotoRuns"
        :line-style="'smooth'"
        color="gray"
        name="No Photo Runs"
      />
    </kendo-chart>
  </div>
</template>

<script>
import { responsiveKendoGridMixin } from '@/mixins/responsiveKendoGridMixin.js';

export default {
  name: 'MediaReportDetailChartPhoto',
  mixins: [
    responsiveKendoGridMixin
  ],
  created () {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize () {
      this.responsiveKendoGridMixin_refresh(this.$refs.chart);
    }
  }
}
</script>

